<template>
  <div class>
    <div class="tab__header">
      <a
        href="#"
        class="flex w-full justify-between items-center question py-2 px-4 tab__title"
        :class="type === 'colored' ? 'bg-jblue-primary' : 'text-xl'"
        @click.prevent="active = !active"
      >
        <div
          class="font-bold"
          :class="type === 'colored' ? 'text-white' : 'text-blue-500 uppercase'"
        >{{title}}</div>
        <span
          class=" down-Arrow text-xs ml-2"
          :class="type === 'colored' ? 'text-white' : 'text-blue-500'"
          v-show="!active"
        >
          ▼
        </span>
        <span
          class=" up-Arrow text-xs ml-2"
          :class="type === 'colored' ? 'text-white' : 'text-blue-500'"
          v-show="active">
          ▲
        </span>
      </a>
    </div>
    <div class="tab__content" v-show="active">
      <slot/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Accordion',
  props: ['title', 'type'],
  data() {
    return {
      active: false
    }
  }
}
</script>
<style>
.down-Arrow {
  transform: rotate(0deg);
}
.up-Arrow {
  transform: rotate(-180deg);
}
.question {
  border-bottom: 1px solid #e2e8f0;
}
</style>
